export default "__VITE_ASSET__D_Xe487A__"